import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/global.css'
import 'echarts'
import ECharts from 'vue-echarts'
import VueAwesomeSwiper from "vue-awesome-swiper";
import 'swiper/css/swiper.css';
import GlobalImage from './views/components/GlobalImage.vue'
Vue.use(ElementUI)
Vue.use(VueAwesomeSwiper)
Vue.component('ECharts', ECharts)
// 引入leaflet
import 'leaflet/dist/leaflet.css';
// 引入插件
import L from "leaflet"

import 'leaflet.chinesetmsproviders';
Vue.config.productionTip = false
Vue.prototype.iframeUrl = (window.location.origin === 'https://cxl.jiankuohao.com') ? 'https://www.chenxinshipping.com/index.php/iframediv.html' : 'http://demo.188388.cn:8083/cz_chenxin/web/index.php/iframediv.html'
Vue.component('global-image', GlobalImage)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
